import React from 'react';
export const Timeline = () => {
  return <div className="w-full bg-white py-12 Timeline" data-id="element-259">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-260">
        <h2 className="text-2xl font-bold text-green-900 text-center mb-2" data-id="element-261">
          Based on Our Formula's Clinically-Proven Ingredients, Here's What You
          Can Expect:*
        </h2>
        <p className="text-gray-500 text-center mb-12 text-sm" data-id="element-262">
          *Based on clinical studies of the ingredients in The Daily Foundation
          Chew™
        </p>
        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-263">
          <div className="bg-amber-50 p-6 rounded-lg" data-id="element-264">
            <div className="flex items-center mb-4" data-id="element-265">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-266">
                <span className="text-green-800 font-bold" data-id="element-267">1</span>
              </div>
              <h3 className="font-bold text-lg" data-id="element-268">Weeks 1-2: Digestive Reset</h3>
            </div>
            <ul className="space-y-2 pl-14" data-id="element-269">
              <li className="flex items-start" data-id="element-270">
                <span className="text-amber-600 mr-2" data-id="element-271">✓</span>
                <span data-id="element-272">Firmer, more regular stools</span>
              </li>
              <li className="flex items-start" data-id="element-273">
                <span className="text-amber-600 mr-2" data-id="element-274">✓</span>
                <span data-id="element-275">Significant reduction in gas and gurgling sounds</span>
              </li>
              <li className="flex items-start" data-id="element-276">
                <span className="text-amber-600 mr-2" data-id="element-277">✓</span>
                <span data-id="element-278">
                  Initial improvement in breath as harmful bacteria decrease
                </span>
              </li>
            </ul>
          </div>
          <div className="bg-amber-50 p-6 rounded-lg" data-id="element-279">
            <div className="flex items-center mb-4" data-id="element-280">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-281">
                <span className="text-green-800 font-bold" data-id="element-282">2</span>
              </div>
              <h3 className="font-bold text-lg" data-id="element-283">
                Weeks 3-6: Energy & Vitality Boost
              </h3>
            </div>
            <ul className="space-y-2 pl-14" data-id="element-284">
              <li className="flex items-start" data-id="element-285">
                <span className="text-amber-600 mr-2" data-id="element-286">✓</span>
                <span data-id="element-287">Visible increase in energy levels</span>
              </li>
              <li className="flex items-start" data-id="element-288">
                <span className="text-amber-600 mr-2" data-id="element-289">✓</span>
                <span data-id="element-290">Shinier, less oily coat</span>
              </li>
              <li className="flex items-start" data-id="element-291">
                <span className="text-amber-600 mr-2" data-id="element-292">✓</span>
                <span data-id="element-293">Breath continues to improve as gut balance restores</span>
              </li>
            </ul>
          </div>
          <div className="bg-amber-50 p-6 rounded-lg" data-id="element-294">
            <div className="flex items-center mb-4" data-id="element-295">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-296">
                <span className="text-green-800 font-bold" data-id="element-297">3</span>
              </div>
              <h3 className="font-bold text-lg" data-id="element-298">
                Weeks 6-12: Complete Transformation
              </h3>
            </div>
            <ul className="space-y-2 pl-14" data-id="element-299">
              <li className="flex items-start" data-id="element-300">
                <span className="text-amber-600 mr-2" data-id="element-301">✓</span>
                <span data-id="element-302">Improved mobility and joint comfort</span>
              </li>
              <li className="flex items-start" data-id="element-303">
                <span className="text-amber-600 mr-2" data-id="element-304">✓</span>
                <span data-id="element-305">Calmer skin with less itching</span>
              </li>
              <li className="flex items-start" data-id="element-306">
                <span className="text-amber-600 mr-2" data-id="element-307">✓</span>
                <span data-id="element-308">Fresh, neutral breath becomes the new normal</span>
              </li>
            </ul>
          </div>
          <div className="bg-amber-50 p-6 rounded-lg" data-id="element-309">
            <div className="flex items-center mb-4" data-id="element-310">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-311">
                <span className="text-green-800 font-bold" data-id="element-312">4</span>
              </div>
              <h3 className="font-bold text-lg" data-id="element-313">
                3+ Months: Long-Term Wellness
              </h3>
            </div>
            <ul className="space-y-2 pl-14" data-id="element-314">
              <li className="flex items-start" data-id="element-315">
                <span className="text-amber-600 mr-2" data-id="element-316">✓</span>
                <span data-id="element-317">Maintained fresh breath without daily brushing</span>
              </li>
              <li className="flex items-start" data-id="element-318">
                <span className="text-amber-600 mr-2" data-id="element-319">✓</span>
                <span data-id="element-320">Stronger immune system</span>
              </li>
              <li className="flex items-start" data-id="element-321">
                <span className="text-amber-600 mr-2" data-id="element-322">✓</span>
                <span data-id="element-323">Overall vitality of a younger dog</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="text-center" data-id="element-324">
          <button className="bg-amber-600 text-white font-semibold py-3 px-8 rounded-full hover:bg-amber-500 transition" onClick={() => {
          document.querySelector('.Founder')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-325">
            Get Started Now
          </button>
        </div>
      </div>
    </div>;
};